import { atom } from 'recoil';
import { FiltersState } from 'shared/types/common';

export const filtersAtom = atom<FiltersState>({
  key: 'filterAtoms',
  default: {},
});
